import React, {  useState} from 'react';
import * as Yup from "yup";
import {ErrorMessage, useForm} from "react-hook-form";
import {connect, useSelector} from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {getStateByPath} from "../../../redux/selectors";

// components
import Separator from "../../../components/Separator";
import SelectGeneric from "../../../components/select/selectGeneric";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {
    FL_DESCRIPTION,
    FL_NAME,
} from "../../../components/i18n/formLabels";
import {TT_CLOSE, TT_SAVE} from "../../../components/i18n/toolTips";
import { PH_DESCRIPTION, PH_NAME} from "../../../components/i18n/placeHolders";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setDataToEdit, setEditMode, setEnabledForm, setFormInfo} from "../../../redux/actions/genericActions";

// services & providers
import {categoryModuleService} from "../../../jwt/_services";
import {applicativeProvider} from "../../../providers/applicativeProvider";

const CategoryModuleForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { editMode, domainObject } = componentState?.data;


    const [appId, setAppId] = useState(domainObject?.app?.id || null);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('El nombre es requerido'),
    });

    const {register, handleSubmit, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            description: domainObject?.description,
            showOrder: domainObject?.showOrder,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data
        }

        if (appId)
            dataRequest.app = { id : appId }
        else
            dataRequest.app = null

        if (!editMode) {
            // console.log('save',  dataRequest);
            // return;
            genericIndexedActions.save(path, categoryModuleService, dataRequest)
        }
        else {
            let id = domainObject.id;
            dataRequest.id = domainObject?.id

            // console.log('update',  dataRequest);
            // return;
            genericIndexedActions.update(path, categoryModuleService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => props.onClose()

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <Card className={ 'card-modal-small' }>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <>
                    <h2 className={'card-modal-title'}> {(domainObject?.title || domainObject?.name || '')}</h2>
                    <br/>
                </>
                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label >{ FL_NAME }</Label>
                            <Input type="text"
                                   name="name"
                                   placeholder={ PH_NAME }
                                   innerRef={register}
                                   className={(errors.name ? ' is-invalid' : '')}
                            />
                            <ErrorMessage errors={errors} name="name" component="div" className="invalid-feedback" />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label >{ 'Orden' }</Label>
                            <Input type="number"
                                   name="showOrder"
                                   step={1}
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>App</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={ appId }
                                setExternalValue={ setAppId }
                                provider={ applicativeProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label >{ FL_DESCRIPTION }</Label>
                            <Input type="textarea"
                                   name="description"
                                   rows="4"
                                   placeholder={ PH_DESCRIPTION }
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </Form>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFormInfo,
    setDataToEdit,
    setEnabledForm,
    setEditMode
})

export default connect(mapStateToProps, mapActionsToProps)(CategoryModuleForm)